document.addEventListener("DOMContentLoaded", function () {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");

      // First close all accordions
      accordionHeaders.forEach((h) => {
        h.classList.remove("active");
        h.nextElementSibling.classList.remove("active");
      });

      // If the clicked one wasn't active, open it
      if (!isActive) {
        this.classList.add("active");
        content.classList.add("active");
      }
      // If it was active, it stays closed (we removed active class above)
    });
  });
});
